<template>
    <div>

        <v-btn
                depressed
                color="blue"
                class="white--text"
                block
                :loading="loading"
                @click="display"
        >
            <v-icon left>mdi-cube-scan</v-icon>
            Aperçu
        </v-btn>

        <v-dialog
                v-model="dialog"
                transition="dialog-bottom-transition"
                persistent
                max-width="3000"
                scrollable

        >
            <v-card>
                <v-toolbar dense flat color="teal" dark>
                    <v-toolbar-title></v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-sheet elevation="6">
                        <v-tabs
                                color="orange"
                                background-color="brown lighten-5"
                                slider-color="orange darken-5"
                                slider-size="5"
                        >
                            <v-tab>
                                <v-icon left>mdi-database-eye-outline</v-icon>
                                Aperçu
                            </v-tab>
                            <v-tab>
                                <v-icon left>mdi-book-open</v-icon>
                                Logs
                            </v-tab>
                            <v-tab-item>
                                <br/>
                                <pay-section-import-display
                                        :pay-section-imports="paySectionImports"
                                        :loading="loading"
                                ></pay-section-import-display>
                            </v-tab-item>
                            <v-tab-item>
                                <br/>
                                <v-simple-table dense fixed-header height="500">
                                    <template v-slot:default>
                                        <tbody>
                                        <tr
                                                v-for="(log, index) in logs"
                                                :key="`log-${index}`"
                                        >
                                            <td>
                                                <strong>{{ log }}</strong>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-tab-item>
                        </v-tabs>
                    </v-sheet>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                            depressed
                            color="teal"
                            outlined
                            @click="dialog = false"
                    >
                        {{ $t('common.close') }}
                        <v-icon right>mdi-close</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import {ref} from "vue";
import PaySectionImportDisplay from "@/views/PaySectionImport/Components/PaySectionImportDisplay.vue";
import useSharedMethod from "@/use/SharedMethod";
import axios from "axios";

export default {
    name: "PreviewFileFreeMode",
    components: {PaySectionImportDisplay},
    props: {
        file: File,
        annexId: Number,
        addZeroValue: Boolean,
        showActionButton: Boolean,
    },
    setup(props) {
        const {translateMonth} = useSharedMethod();

        const dialog = ref(false);
        const loading = ref(false);
        const paySectionImports = ref([]);
        const logs = ref([]);

        function display() {
            if (props.file) {
                loading.value = true;
                const formData = new FormData();
                formData.append("file", props.file);
                axios.put(`/paySectionImport/previewFreeMode`, formData, {
                    params: {
                        annexId: props.annexId,
                        addZeroValue: props.addZeroValue,
                    }
                }).then(response => {
                    paySectionImports.value = response.data.elements;
                    logs.value = response.data.logs;
                    dialog.value = true
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        return {
            dialog,
            loading,
            paySectionImports,
            logs,
            display,
            translateMonth
        }
    }
}
</script>

<style scoped>

</style>